<template>
    <div id="get-project" class="get-project">
        <img src="../assets/img/dots.webp" class="line" alt="Background image" >
        <div class="container">
            <div class="row">
                <div class="col-lg-6 left">
                    <div v-scrollanimation>
                        <h3 class="main-title">
                            {{ $t('get_project.main_title') }}
                        </h3>
                        <p class="text">
                            {{ $t('get_project.title') }}
                        </p>
                    </div>
                </div>
                <div class="col-lg-6 right">
                    <a href="get-project">
                        <my-button :text="$t('get_project.get_button')" v-scrollanimation></my-button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MyButton from "@/components/MyButton.vue"
export default {
    name: "GetProject",
    components: {
        MyButton,
    },
    data() {
        return {
        };
    },
    mounted() { },
};
</script>

<style lang="scss">
.get-project {
    background: linear-gradient(290deg, #244879e5, var(--main-blue));
    color: #fff;
    position: relative;
}

html:lang(ar) .get-project .main-title {
    font-size: 40px;
}

.get-project .main-title {
    font-size: 45px;
    font-weight: bold;
    text-align: justify;
}

html:lang(ar) .get-project .text {
    font-size: 20px;
    margin-top: 20px;
}

.get-project .text {
    margin-top: 10px;
    letter-spacing: 1.5px;
    text-align: justify;
}

.get-project .line {
    position: absolute;
    top: 0;
    right: 0;
}

@media (min-width: 992px) {
    .get-project .right {
        text-align: end;
    }

    .get-project .line {
        height: 100%;
        opacity: 70%;
    }

    .get-project {
        padding: 100px 150px;
    }
}

@media (max-width: 991px) {
    .get-project .right {
        text-align: justify;
    }

    .get-project .line {
        opacity: 60%;
        height: 60%;
    }

    .get-project {
        padding: 50px;
    }

    .get-project .main-title {
        font-size: 30px;
    }
    html:lang(ar) .get-project .main-title {
        font-size: 30px;
    }

}

html:lang(en) .get-project .left .before-enter {
    opacity: 0;
    transform: translateX(-65px);
    transition: all 1s ease;
}

html:lang(ar) .get-project .left .before-enter {
    opacity: 0;
    transform: translateX(65px);
    transition: all 1s ease;
}

html:lang(ar) .get-project .left .enter,
html:lang(en) .get-project .left .enter {
    opacity: 1;
    transform: translateX(0px);
}

html:lang(en) .get-project .right .before-enter {
    opacity: 0;
    transform: translateX(65px);
    transition: all 1s ease;
}

html:lang(ar) .get-project .right .before-enter {
    opacity: 0;
    transform: translateX(-65px);
    transition: all 1s ease;
}

html:lang(ar) .get-project .right .enter,
html:lang(en) .get-project .right .enter {
    opacity: 1;
    transform: translateX(0px);
}</style>
